import {
  TAffiliation,
  TPartialAttributesMatchingRow,
} from '@timeedit/types/lib/types';
import { convertPartialAttributesRowToAffiliation } from '@timeedit/types/lib/utils';

/**
 * Wraps `convertPartialAttributesRowToAffiliation` from `@timeedit/types`
 * with UI-specific defaults used by the legacy-affiliation migration flow:
 *
 *   - Empty/missing labels are replaced with `Legacy affiliation N` -
 *     the new API rejects empty labels and legacy rows have no requirement
 *     to fill the description cell.
 *   - Falsy `userObjects` entries are stripped — legacy rows can contain
 *     empty-string IDs which the new affiliations API rejects.
 *
 * `authConfigId` is omitted from the return type; the caller fills it in.
 */
export const mapRowToAffiliation = (
  row: TPartialAttributesMatchingRow,
  index: number
): Omit<TAffiliation, 'authConfigId'> => {
  const { authConfigId: _ignored, ...affiliation } =
    convertPartialAttributesRowToAffiliation(row, '', index);

  return {
    ...affiliation,
    label: affiliation.label || `Legacy affiliation ${index + 1}`,
    userObjects: affiliation.userObjects.filter(Boolean),
    organizationsAndRoles: affiliation.organizationsAndRoles.filter(
      (o) => o.organizationId || o.role
    ),
    matchingCriteria: affiliation.matchingCriteria.filter(
      (c) => c.attribute || c.value
    ),
  };
};
